export default __webpack_public_path__ + "static/media/basicsEpa.419d0b27.jpg";